import { useState, type ReactNode } from 'react';
import type { Variant } from '../types';

export interface AlertProps {
  variant?: Variant;
  /** Phosphor icon class shown at the start, e.g. "ph-info". */
  icon?: string;
  /** Render a dismiss button. */
  dismissible?: boolean;
  children?: ReactNode;
  className?: string;
}

export function Alert({
  variant = 'primary',
  icon,
  dismissible = false,
  children,
  className = '',
}: AlertProps) {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  const classes = [
    'alert',
    `alert-${variant}`,
    icon ? 'alert-icon-start' : '',
    dismissible ? 'alert-dismissible' : '',
    'fade',
    'show',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="alert">
      {icon && <i className={`${icon} me-2`} />}
      {children}
      {dismissible && (
        <button type="button" className="btn-close" aria-label="Close" onClick={() => setOpen(false)} />
      )}
    </div>
  );
}
